import React, { useState, useRef, useEffect } from "react";
import { LayoutHome } from "./LayoutHome";
import {
  Card,
  Table as TblAntd,
  Button,
  Input,
  Space,
  notification,
} from "antd";
import {
  Checkbox,
  Text,
  Tag,
  Tabs,
  SelectPicker,
  NumberInput,
  DateInput,
  Table,
  toaster,
  Message,
  IconButton,
  Box,
  InputGroup,
  Input as Inpt,
} from "rsuite";
import { FaSave } from "react-icons/fa";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import moment from "moment/moment";
import SearchIcon from "@rsuite/icons/Search";
import CloseOutlineIcon from "@rsuite/icons/CloseOutline";
import {
  getStockInsumo,
  getInventarioInsumos,
  saveInsumo,
  saveEntradaInsumo,
} from "./Services/SesionHemoServices";
import {
  getCatInsumos,
  getListaInsumos,
  getListPreciosInsumos,
  updatePrecioInsumo,
} from "./Services/CatalogosServices";
import { reformatDateString, soloNumeros } from "../Utils";
import { VscEdit, VscSave } from "react-icons/vsc";

const { Column, HeaderCell, Cell } = Table;

const styles = `
.table-cell-editing .rs-table-cell-content {
  padding: 4px;
}
.table-cell-editing .rs-input {
  width: 100%;
}
`;

export const Insumos = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [idInsumo, setIdInsumo] = useState(0);
  const [insumo, setInsumo] = useState("");
  const [nombreCorto, setNombrecorto] = useState("");
  const [marca, setMarca] = useState("");
  const [esMedica, setEsMedica] = useState(0);
  const [activo, setActivo] = useState(1);
  const [data, setData] = useState([]);
  const [dataInv, setDataInv] = useState([]);
  const [dataInsumos, setDataInsumos] = useState([]);

  const [idInsumoInv, setIdInsumoInv] = useState(null);
  const [lote, setLote] = useState("");
  const [fecCad, setFecCad] = useState(null);
  const [cantidad, setCantidad] = useState(0);
  const [stock, setStock] = useState(0);
  const [msjFecha, setMsjFecha] = useState("");

  const [precioA, setPrecioA] = useState(0);
  const [precioNvo, setPrecioNvo] = useState(0);

  const [api, contextHolder] = notification.useNotification();

  const initialized = useRef(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [filteredData, setFilteredData] = useState(data);

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data);
    nextData.find((item) => item.id === id)[key] = value;
    setData(nextData);
  };

  const handleEdit = (id) => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setData(nextData);
  };

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Insumo",
      dataIndex: "insumo",
      width: "40%",
      key: "insumo",
      sorter: (a, b) => a.insumo.length - b.insumo.length,
      ...getColumnSearchProps("insumo"),
    },
    {
      title: "Marca",
      dataIndex: "marca",
      width: "15%",
      key: "marca",
      ...getColumnSearchProps("marca"),
      align: "center",
    },
    {
      title: "Nombre corto",
      dataIndex: "nombreCorto",
      width: "20%",
      key: "nombreCorto",
      ...getColumnSearchProps("nombreCorto"),
    },
    {
      title: "Es Medicamento",
      dataIndex: "esMedica",
      width: "10%",
      key: "esMedica",
      align: "center",
      render: (text) =>
        text === 1 ? <Tag color="blue">Si</Tag> : <Tag color="#000">No</Tag>,
    },
    {
      title: "Estatus",
      dataIndex: "activo",
      width: "5%",
      key: "activo",
      align: "center",
      render: (text) =>
        text === 1 ? (
          <Tag color="green">Activo</Tag>
        ) : (
          <Tag color="red">Inactivo</Tag>
        ),
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "5%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<EditOutlined />}
          color="primary"
          variant="outlined"
          onClick={() =>
            editInsumo({
              idInsumo: record.idInsumo,
              insumo: record.insumo,
              nombreCorto: record.nombreCorto,
              esMedica: record.esMedica,
              activo: record.activo,
            })
          }
        ></Button>
      ),
    },
  ];

  const columunsInv = [
    {
      title: "Insumo",
      dataIndex: "insumo",
      width: "30%",
      key: "insumo",
      sorter: (a, b) => a.insumo.length - b.insumo.length,
      ...getColumnSearchProps("insumo"),
    },
    {
      title: "Lote",
      dataIndex: "lote",
      width: "15%",
      key: "lote",
      ...getColumnSearchProps("lote"),
      align: "center",
    },
    {
      title: "Fecha Cad.",
      dataIndex: "fecCad",
      width: "10%",
      key: "fecCad",
      ...getColumnSearchProps("fecCad"),
      align: "center",
    },
    {
      title: "Es Medicamento",
      dataIndex: "esMedica",
      width: "15%",
      key: "esMedica",
      align: "center",
      render: (text) =>
        text === 1 ? <Tag color="blue">Si</Tag> : <Tag color="#000">No</Tag>,
    },
    {
      title: "Cantidad inicial",
      dataIndex: "cantidad",
      width: "12%",
      key: "cantidad",
      align: "center",
    },
    {
      title: "Stock actúal",
      dataIndex: "stock",
      width: "12%",
      key: "stock",
      align: "center",
    },
  ];

  const handleSearchTable = (value) => {
    setSearchKeyword(value);

    // Filter data across all columns
    const filtered = data.filter((item) => {
      // Check each field for matches
      return Object.keys(item).some((key) =>
        String(item[key]).toLowerCase().includes(value.toLowerCase()),
      );
    });

    setFilteredData(filtered);
  };

  const editInsumo = (props) => {
    setIdInsumo(props.idInsumo);
    setInsumo(props.insumo);
    setNombrecorto(props.nombreCorto);
    setEsMedica(props.esMedica);
    setActivo(props.activo);
  };

  const loadInsumos = async () => {
    await getListaInsumos(idNegocio)
      .then((res) => {
        setData(res);
        setFilteredData(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const checkMedicamento = (e) => {
    if (e.target.checked) {
      setEsMedica(1);
    } else {
      setEsMedica(0);
    }
  };

  const loadCatalogo = async () => {
    await getCatInsumos(idNegocio)
      .then(async (res) => {
        setDataInsumos(res);
        await getInventarioInsumos(idNegocio).then((res) => {
          setDataInv(res);
        });
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        }
      });
  };

  const checkActivo = (e) => {
    if (e.target.checked) {
      setActivo(1);
    } else {
      setActivo(0);
    }
  };

  const handleFecCaduca = (e) => {
    var esFecha = moment(e, "DD/MM/YYYY").isValid();
    if (esFecha) {
      var fec = new Date(e).toISOString();
      var fecha = moment(fec).format("DD/MM/YYYY");
      setFecCad(fecha);
      setMsjFecha("");
    } else {
      if (e === null) {
        setMsjFecha("");
      } else {
        setMsjFecha("** Formato incorrecto **");
      }
    }
  };

  const handleStock = async (e) => {
    setIdInsumoInv(e);
    await getStockInsumo(idNegocio, e, 0)
      .then((res) => {
        setStock(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const save = async () => {
    const data = {
      id: idNegocio,
      idInsumo: idInsumo,
      insumo: insumo,
      nombreCorto: nombreCorto,
      esMedica: esMedica,
      activo: activo,
    };
    await saveInsumo(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Insumo",
            "Se ha guardado la información de forma correcta.",
          );
          setIdInsumo(0);
          setInsumo("");
          setNombrecorto("");
          setActivo(1);
          setEsMedica(0);
          loadInsumos();
        } else {
          errorNotificaction("Error", "No se registro la información");
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const saveIngresoInsumo = async () => {
    var esFecha = moment(fecCad, "DD/MM/YYYY").isValid();
    let fecCaduca = "";
    if (esFecha) {
      fecCaduca = reformatDateString(fecCad);
    }

    const data = {
      id: idNegocio,
      idUser: idUser,
      idInsumo: idInsumoInv,
      lote: lote,
      fechaCaduca: fecCaduca,
      cantidad: cantidad,
    };
    await saveEntradaInsumo(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Entrada de insumo",
            "Se ha registrado la información de forma correcta.",
          );
          loadInsumos()
            .then(async (nxt) => {
              await getInventarioInsumos(idNegocio).then((res) => {
                setDataInv(res);
                loadCatalogo().then((nxt) => {
                  setLote("");
                  setFecCad(null);
                  setCantidad(0);
                  setMsjFecha("");
                  setIdInsumoInv(null);
                  setStock(0);
                });
              });
            })
            .catch((err) => {
              errorNotificaction(err.name, err.message);
            });
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleNuevoPrecio = (event) => {
    setPrecioNvo(soloNumeros(event));
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadInsumos().then((res) => {
        loadCatalogo();
      });
    }
  }, []);

  return (
    <>
      <title>Catálogo de Insumos - NefroSys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Inicio
              </a>
            ),
          },
          { title: "Catálogo de Insumos" },
        ]}
        selectedKey={"1.5"}
      >
        {contextHolder}
        <Tabs defaultActiveKey={"1"}>
          <Tabs.Tab eventKey="1" title="Catálogo de Insumos">
            <Card>
              <div className="row mb-3">
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Text>Nombre del Insumo</Text>
                  <Input
                    value={insumo}
                    onChange={(e) => setInsumo(e.target.value)}
                    placeholder="Escribe el nombre el medicamento o material de curación..."
                  />
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Text>Nombre corto</Text>
                  <Input
                    value={nombreCorto}
                    onChange={(e) => setNombrecorto(e.target.value)}
                    disabled={insumo.length > 0 ? false : true}
                    placeholder="Escribe el nombre corto..."
                  />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Text>Marca</Text>
                  <Input
                    value={marca}
                    onChange={(e) => setMarca(e.target.value)}
                    placeholder="Escribe la marca..."
                  />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Text>Es medicamento</Text>
                  <Checkbox
                    onClick={(e) => checkMedicamento(e)}
                    checked={esMedica === 1 ? true : false}
                  />
                </div>
                <div className="col-lg-1 col-md-1 col-sm-1">
                  <Text>Activo</Text>
                  <Checkbox
                    onClick={(e) => checkActivo(e)}
                    checked={activo === 1 ? true : false}
                  />
                </div>
                <div className="text-center col-lg-1 col-md-1 col-sm-1">
                  <br></br>
                  <Button
                    type="primary"
                    onClick={save}
                    disabled={
                      insumo.length > 0 && nombreCorto.length > 0 ? false : true
                    }
                    icon={<FaSave></FaSave>}
                  >
                    Guardar
                  </Button>
                </div>
              </div>
            </Card>
            <br></br>
            <Card title="Lista de Insumos">
              <div className="row mb-2">
                <div className="col">
                  <TblAntd
                    bordered
                    size="small"
                    rowKey={(record) => record.insumo}
                    columns={columns}
                    dataSource={data}
                    pagination={{ pageSize: 20 }}
                  />
                </div>
              </div>
            </Card>
          </Tabs.Tab>
          <Tabs.Tab eventKey="2" title="Inventario">
            <Card>
              <div className="row mb-2">
                <div className="col-lg-5 col-md-5 col-sm-5">
                  <Text>Insumo</Text>
                  <SelectPicker
                    value={idInsumoInv}
                    data={dataInsumos}
                    onChange={(e) => handleStock(e)}
                    block
                    placeholder="-- Selecciona --"
                  />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Text>Lote</Text>
                  <Input
                    value={lote}
                    onChange={(e) => setLote(e.target.value)}
                  />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Text>Fecha caducidad</Text>
                  <DateInput
                    format="dd/MM/yyyy"
                    value={fecCad}
                    onChange={(e) => handleFecCaduca(e)}
                  />
                  <Text size="xs" color={"red"}>
                    {msjFecha}
                  </Text>
                </div>
                <div className="col-lg-1 col-md-1 col-sm-1">
                  <Text>Cantidad</Text>
                  <NumberInput
                    min={1}
                    value={cantidad}
                    controls={false}
                    onChange={(e) => setCantidad(e)}
                    disabled={idInsumoInv !== null ? false : true}
                  />
                  <Text size="xs" color={"red"} style={{ paddingTop: "5px" }}>
                    Por pieza
                  </Text>
                </div>
                <div className="text-center col-lg-1 col-md-1 col-sm-1">
                  <Text>Stock</Text>
                  <Input
                    value={stock}
                    readOnly
                    style={{ textAlign: "center" }}
                  />
                </div>
                <div className="text-end col-lg-1 col-md-1 col-sm-1">
                  <br></br>
                  <Button
                    type="primary"
                    onClick={saveIngresoInsumo}
                    icon={<FaSave></FaSave>}
                    disabled={Number(cantidad) > 0 ? false : true}
                  >
                    Guardar
                  </Button>
                </div>
              </div>
            </Card>
            <br></br>
            <Card title="Inventario de Insumos">
              <div className="row mb-2">
                <div className="col">
                  <TblAntd
                    key={"tbl-InventInsumos"}
                    bordered
                    size="small"
                    rowKey={(record) => record.insumo}
                    columns={columunsInv}
                    dataSource={dataInv}
                    pagination={{ pageSize: 20 }}
                  />
                </div>
              </div>
            </Card>
          </Tabs.Tab>
          <Tabs.Tab eventKey="3" title="Precios">
            <Card title="Listado de precios">
              <div className="row mb-3">
                <div className="col">
                  <Box mb={10}>
                    <InputGroup inside style={{ width: 300 }}>
                      <Inpt
                        placeholder="Buscar..."
                        value={searchKeyword}
                        onChange={handleSearchTable}
                      />
                      {searchKeyword ? (
                        <InputGroup.Button
                          onClick={() => handleSearchTable("")}
                        >
                          <CloseOutlineIcon />
                        </InputGroup.Button>
                      ) : (
                        <InputGroup.Addon>
                          <SearchIcon />
                        </InputGroup.Addon>
                      )}
                    </InputGroup>
                  </Box>
                  <Table
                    height={400}
                    hover={true}
                    showHeader={true}
                    data={filteredData}
                    bordered={true}
                    cellBordered={true}
                    headerHeight={30}
                    rowHeight={50}
                    style={{ borderRadius: "5px" }}
                  >
                    <Column flexGrow={1}>
                      <HeaderCell
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          backgroundColor: "#F5F5F5",
                        }}
                      >
                        Nombre del Insumo
                      </HeaderCell>
                      <Cell dataKey="insumo" dataType="string" />
                    </Column>

                    <Column width={200} align="center">
                      <HeaderCell
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          backgroundColor: "#F5F5F5",
                        }}
                      >
                        Stock
                      </HeaderCell>
                      <Cell dataKey="stock" dataType="string" />
                    </Column>

                    <Column width={200}>
                      <HeaderCell
                        align="center"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          backgroundColor: "#F5F5F5",
                        }}
                      >
                        Precio anterior
                      </HeaderCell>
                      <Cell
                        align="center"
                        dataKey="precioAnt"
                        dataType="string"
                        readOnly
                      />
                    </Column>

                    <Column width={200}>
                      <HeaderCell
                        align="center"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          backgroundColor: "#F5F5F5",
                        }}
                      >
                        Precio actúal
                      </HeaderCell>
                      <EditableCell
                        align="center"
                        dataKey="precio"
                        dataType="number"
                        onChange={handleChange}
                        onEdit={handleEdit}
                      />
                    </Column>

                    <Column width={100}>
                      <HeaderCell
                        align="center"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          backgroundColor: "#F5F5F5",
                        }}
                      >
                        Acciones
                      </HeaderCell>
                      <ActionCell dataKey="id" onEdit={handleEdit} />
                    </Column>
                  </Table>
                </div>
              </div>
            </Card>
          </Tabs.Tab>
        </Tabs>
      </LayoutHome>
    </>
  );
};

function toValueString(value, dataType) {
  return dataType === "date" ? value?.toLocaleDateString() : value;
}

const fieldMap = {
  string: Input,
  number: NumberInput,
  picker: SelectPicker,
};

const EditableCell = ({
  rowData,
  dataType,
  dataKey,
  onChange,
  onEdit,
  ...props
}) => {
  const editing = rowData.status === "EDIT";

  const Field = fieldMap[dataType];
  const value = rowData[dataKey];
  const text = toValueString(value, dataType);

  return (
    <Cell
      {...props}
      className={editing ? "table-cell-editing" : ""}
      onDoubleClick={() => {
        onEdit?.(rowData.id);
      }}
    >
      {editing ? (
        <Field
          defaultValue={value}
          searchable={false}
          min={0}
          data={[
            { label: "SI", value: "SI" },
            { label: "NO", value: "NO" },
          ]}
          onChange={(value) => {
            onChange?.(rowData.id, dataKey, value);
          }}
        />
      ) : (
        text
      )}
    </Cell>
  );
};

const toast = (msg, type = "info") => {
  toaster.push(
    <Message showIcon type={type} closable>
      <strong>{type}!</strong>
      &nbsp; {msg}
    </Message>,
    { duration: 5000, placement: "topCenter" },
  );
};

const saveRecord = async (id, rowData, mode) => {
  if (mode === "EDIT") {
    return;
  }

  const idNegocio = JSON.parse(localStorage.getItem("auth")).id;
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;

  const data = {
    IdConsultorio: idNegocio,
    IdInsumo: rowData.id,
    Insumo: "",
    IdPrecio: rowData.idPrecio,
    Precio: rowData.precio,
    IdUser: idUser,
    Estatus: rowData.estatus,
  };

  await updatePrecioInsumo(data)
    .then(async (res) => {
      if (res.data === 1) {
        toast("El registro se ha actualizado de forma correcta", "success");
      } else {
        toast("No se ha registrado la información", "warning");
      }
    })
    .catch((error) => {
      toast("Ha ocurrido un error inesperado.", "error");
      console.log(error);
    });
};

const ActionCell = ({ rowData, dataKey, onEdit, onRemove, ...props }) => {
  return (
    <Cell
      {...props}
      style={{ padding: "6px", display: "flex", gap: "4px" }}
      align="center"
    >
      <IconButton
        appearance="subtle"
        icon={rowData.status === "EDIT" ? <VscSave /> : <VscEdit />}
        onClick={() => {
          onEdit(rowData.id);
          saveRecord(rowData.id, rowData, rowData.status);
        }}
      />
    </Cell>
  );
};
